import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';

import Logo from '../../images/logo.svg'
import Termsconditions from '../../components/termsconditions/termsconditions';


const TermsPage = () => {
    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={'Terms and Conditions'}  />
            
           <Termsconditions />
            <Footer />
            <Scrollbar />

        </Fragment>
    )
};
export default TermsPage ;
